import { useState } from "react";
import { useTab } from "@/hooks/useTab";
import { useFilters } from "@/hooks/useFilters";
import { AchievementsPodium } from "@/components/cards/AchievementsPodium";
import { AchievementsDetailModal } from "@/components/AchievementsDetailModal";
import { AchievementsRankingRow } from "./AchievementsRankingRow";
import { EmptyState, ErrorState, SectionTitle, TabSkeleton } from "./shared";
import type { AchievementPodiumRow } from "@/api/types";

/** Tab 7 — Medal count podium + full medal ranking. Clicking a row
 * opens the detail modal with earned/locked medals. */
export function AchievementsTab() {
  const { filters } = useFilters();
  const { data, isPending, error } = useTab("achievements", filters);
  const [selectedUser, setSelectedUser] = useState<AchievementPodiumRow | null>(null);

  if (isPending) return <TabSkeleton />;
  if (error) return <ErrorState error={error} />;
  if (!data || (data.podium.length === 0 && data.ranking.length === 0)) {
    return <EmptyState title="Sin logros registrados." />;
  }

  const top3 = data.podium.slice(0, 3);

  return (
    <div className="flex flex-col gap-8">
      <section>
        <SectionTitle>Coleccionistas</SectionTitle>
        <AchievementsPodium
          top3={top3}
          onSelect={(u) => {
            if ("total_score" in u && "medals" in u) setSelectedUser(u);
          }}
        />
      </section>
      <section>
        <SectionTitle>Ranking de medallas</SectionTitle>
        <div className="flex flex-col gap-2">
          {data.ranking.map((row) => (
            <AchievementsRankingRow
              key={row.uid}
              row={row}
              onClick={() => setSelectedUser(row)}
            />
          ))}
        </div>
      </section>
      <AchievementsDetailModal
        user={selectedUser}
        onClose={() => setSelectedUser(null)}
      />
    </div>
  );
}
